import './style.less';
import LandingCircle from 'components/Circle/LandingCircle';
import HowToCircle from 'components/Circle/HowToCircle';
import { useState } from 'react';
import Layout from 'containers/Layout';
import { useNavigate } from 'react-router-dom';
// import DrawSVG from 'react-svg-drawing';

const Home = () => {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const slides = [
    <LandingCircle onclick={() => setIndex((i) => i + 1)} />,
    <HowToCircle
      image={
        // <DrawSVG duration={500} width="unset" />

        <svg scale={0.8} width="259" height="254" viewBox="0 0 259 254" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M42.0532 97.8291C27.3697 101.315 1.81789 105.921 3.04246 126.797C4.29886 148.216 36.0624 143.265 47.702 137.033C60.7537 130.045 69.8861 114.83 54.0268 105.168C46.6172 100.653 37.4087 100.436 29.0174 100.436"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M235.851 104.781C227.759 104.921 219.801 105.58 212.435 109.465C201.59 115.185 198.679 125.423 207.125 134.667C215.72 144.076 231.19 143.166 241.355 137.322C248.754 133.069 261.246 121.164 253.619 111.879C246.496 103.207 232.111 102.8 221.947 101.305"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M140.256 152.579C121.817 147.628 96.4232 143.684 85.6022 163.636C81.8714 170.514 81.1039 179.09 84.1538 186.376C89.1076 198.21 102.567 201.271 114.136 202.26C131.103 203.711 160.722 197.377 149.236 173.823C142.879 160.786 128.441 151.069 114.184 149.972"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M58.5653 13.5311C59.1471 33.9745 60.5172 54.673 59.6274 75.1371C59.584 76.1362 59.6524 77.7334 59.2412 78.7099C57.4221 83.0302 65.5367 83.0489 68.4628 83.4414C85.7006 85.7538 103.362 84.642 120.702 85.2278C137.375 85.7911 153.986 86.5314 170.673 86.5314C179.76 86.5314 189.076 85.8952 198.096 87.2073C202.62 87.8653 203.697 87.4611 203.697 82.5724C203.697 57.6126 201.09 32.8872 201.09 7.93058C201.09 7.00388 201.616 4.18019 200.414 4.01986C188.765 2.46665 175.872 3.16753 164.107 3.10252C139.468 2.9664 115.351 4.61595 90.8167 6.57873C77.2429 7.66463 63.4866 9.18588 49.8748 9.18588"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path d="M122.728 85.9155V105.506" stroke="black" strokeWidth="5" strokeLinecap="round" />
          <path
            d="M103.863 112.036C125.632 113.015 147.415 113.73 169.164 114.938"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M140.142 24.9682C141.751 36.0571 143.044 47.3638 143.044 58.586C143.044 64.1838 149.409 62.5806 154.048 62.6573C161.006 62.7723 167.97 62.6976 174.928 62.6976C176.167 62.6976 179.063 63.1514 180.37 62.5363C183.439 61.0922 178.621 44.0323 178.314 41.1725C177.973 37.9842 179.333 28.7035 176.42 26.0969C173.948 23.885 168.829 24.9682 165.778 24.9682C157.7 24.9682 149.659 24.5934 141.593 24.2427"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M148.123 32.9497C148.123 37.1213 146.538 40.3207 151.267 40.2054C152.79 40.1682 154.653 38.8532 154.653 37.2628C154.653 34.558 155.752 34.2232 153.202 33.3125C150.75 32.4369 146.563 34.4008 143.77 34.4008"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M166.987 34.4006C166.987 39.4481 167.016 41.8701 172.469 38.754C173.988 37.8862 174.034 33.9777 173.356 32.5464C173.12 32.048 168.267 34.216 167.713 34.4006"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M148.848 48.9123C149.001 49.7148 148.925 56.0033 149.735 56.7323C152.134 58.8913 155.676 54.9868 155.943 52.9433C156.251 50.5804 156.104 48.1461 156.104 45.7682C156.104 44.9387 155.857 47.8091 155.056 48.0255C152.083 48.829 148.329 48.1868 145.22 48.1868"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M69.0364 20.6148C71.8308 20.7658 82.0965 17.7399 82.0965 20.776C82.0965 22.6943 81.0993 29.9306 83.8701 25.7743C84.4182 24.9522 91.2689 16.6293 91.4886 18.2768C91.6654 19.6032 90.5219 25.6884 92.7785 25.4922C97.3393 25.0956 100.701 19.9765 105.798 20.776C107.535 21.0485 98.4701 25.6107 97.2125 25.9759C93.3753 27.0899 102.674 23.9852 103.702 23.8395C107.11 23.3565 110.588 23.517 114.021 23.517"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M83.5476 46.7353C96.5297 44.3622 106.949 44.3209 119.826 46.7353"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M71.9387 48.1869C80.8054 52.4356 72.7731 43.6262 71.2938 50.283C70.5542 53.6108 75.9554 49.6381 71.2131 49.6381"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M74.1152 64.8744C75.1805 63.6483 78.3272 59.9369 77.1787 61.0853C76.1732 62.0908 76.3843 62.6928 76.171 62.0528C75.8615 61.1243 74.1152 64.1488 74.1152 64.1488"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M88.6265 64.1484C97.1011 64.0772 105.552 63.7149 114.021 63.4229"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M27.1387 146.449C28.0567 164.053 29.5401 181.875 33.222 199.152C33.75 201.63 33.9594 195.298 33.9825 194.882"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path d="M30.8237 166.981L55.0402 154.346" stroke="black" strokeWidth="5" strokeLinecap="round" />
          <path
            d="M48.7943 144.44C47.4172 150.786 47.638 157.441 48.7824 163.826C48.9408 164.709 49.457 167.591 50.5027 168.169C50.7106 168.283 52.4902 166.955 52.7095 166.875C54.8203 166.104 57.1283 165.836 59.3534 165.63C60.8186 165.494 61.5894 164.98 62.5567 163.921C63.2153 163.2 64.1899 162.764 64.1702 161.643C64.1465 160.294 63.6287 158.977 63.1736 157.728C62.3015 155.335 61.4665 152.961 60.7533 150.515C60.0902 148.24 59.66 144.777 58.1432 142.827C57.2671 141.7 54.0792 141.874 52.9467 142.02C49.462 142.469 45.7505 143.192 42.3877 144.227"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M231.018 143.153C234.469 161.584 237.99 180.005 241.223 198.475"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M231.018 166.249C223.359 164.76 215.242 162.489 207.385 162.489"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M206.311 151.21C207.873 157.994 208.459 164.557 208.459 171.501C208.459 172.154 208.888 174.478 207.982 174.723C203.062 176.053 198.336 173.414 194.256 171.083C193.353 170.567 193.957 166.068 193.957 165.413C193.957 163.613 192.68 154.148 194.942 153.478C197.088 152.842 199.96 153.358 202.193 153.358C204.298 153.358 206.409 152.694 208.459 152.284"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M120.374 203.847C120.468 216.925 120.83 229.878 122.283 242.876C122.589 245.614 122.522 248.363 122.522 251.112"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M116.614 222.108C108.566 217.082 100.506 212.073 92.4441 207.069"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M86.536 199.55C87.5257 204.438 88.9805 209.045 90.2361 213.753C90.8462 216.041 89.9024 216.761 87.6401 216.946C82.5137 217.366 79.2634 214.551 74.6003 213.515C72.7004 213.092 73.1083 211.094 73.1083 209.516C73.1083 204.941 73.1083 200.365 73.1083 195.79C73.1083 190.534 81.5952 194.157 84.3876 194.716"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
        </svg>
      }
      description="First, upload your notes to generate questions!"
      buttonText="Next"
      back={() => setIndex((i) => i - 1)}
      next={() => setIndex((i) => i + 1)}
    />,
    <HowToCircle
      image={
        <svg width="463" height="236" viewBox="0 0 463 236" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M309.943 38.799C287.627 41.458 240.505 56.6753 250.938 87.4821C258.273 109.14 292.482 109.826 310.946 106.398C334.532 102.019 350.256 81.4896 340.524 58.2623C331.585 36.9305 308.866 32.446 288.286 28.9429"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M299.697 112.943C297.757 132.445 298.605 152.378 298.83 171.943C299.019 188.355 302.451 204.642 302.451 220.943"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M297.451 159.943C314.986 156.385 349.451 146.943 349.451 146.943"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M333.963 123.613C333.963 137.903 333.449 152.428 334.857 166.672C335.521 173.396 344.962 167.871 348.361 166.623C350.491 165.841 364.181 163.202 364.447 160.366C364.539 159.387 363.079 153.852 363.057 153.764C361.405 147.143 359.697 140.54 358.291 133.86C357.931 132.151 357.621 119.314 354.021 119.967C347.348 121.178 341.212 125.331 334.559 126.963C330.195 128.033 325.776 128.65 321.451 129.82"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M364.451 120.943C368.961 112.292 374.814 103.951 378.451 94.9429"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M379.451 138.943C391.935 146.093 405.572 153.298 416.451 162.943"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M403.451 79.9429C405.49 98.8201 407.003 117.813 412.007 136.147C412.977 139.702 413.433 143.485 414.044 147.111C414.257 148.376 414.451 151.985 414.451 148.395"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M401.451 72.8223C415.122 70.4181 428.184 69.242 441.991 69.242C444.509 69.242 450.403 67.9204 451.494 70.8332C453.726 76.7917 453.035 83.7935 453.516 90.0277C454.038 96.7946 455.579 103.432 455.942 110.217C456.467 120.032 457.531 129.953 457.863 139.754C457.885 140.397 457.625 141.558 457.964 142.141C458.092 142.36 460.031 143.052 459.278 143.335C455.967 144.576 450.475 143.533 447.046 143.533C442.578 143.533 437.454 144.157 433.448 141.793C429.218 139.296 422.677 143.533 417.829 143.533"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M414.451 89.5545C415.497 89.7482 417.065 90.464 416.201 88.7261C416.119 88.5614 415.07 86.3001 414.725 87.1223C413.806 89.3133 416.095 91.5764 416.095 88.2855"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M419.077 112.943C418.997 112.002 418.973 111.486 418.822 110.585C418.741 110.1 418.269 109.408 418.528 109.157C418.825 108.87 419.326 110.579 419.421 110.021C419.616 108.863 418.791 107.379 419.254 108.161"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M422.128 129.741C418.999 129.9 421.182 131.118 421.319 130.921C421.764 130.281 422.104 129.608 422.451 128.943C422.456 128.934 422.286 129.188 422.128 129.188"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M423.451 87.9429C424.814 87.5741 426.09 87.2396 427.264 86.4845C427.544 86.3046 428.042 85.7384 428.454 85.6929C429.485 85.579 430.694 86.7061 431.535 87.0818C434.336 88.3325 436.219 87.7652 438.917 86.804C439.449 86.6145 440.038 86.711 440.595 86.6929C442.115 86.6434 443.652 86.2808 445.17 86.1373C445.979 86.0608 448.691 85.5207 446.787 84.9429"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M424.451 98.9429C428.407 96.7479 431.749 94.4156 436.263 95.4191C438.029 95.8116 440.094 95.5143 441.893 95.5143C442.264 95.5143 445.178 95.8748 444.28 94.9429"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M428.451 112.943C430.907 111.401 433.351 109.775 435.936 108.479C436.676 108.108 437.675 107.582 438.527 107.904C439.622 108.318 440.909 110 441.678 110.948C442.032 111.385 446.474 106.563 447.451 105.943"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M427.451 126.943C430.392 126.655 433.363 126.3 436.244 125.727C438.003 125.378 439.268 124.898 441.142 124.946C442.693 124.986 450.009 127.355 450.451 126.273"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M123.854 15.395C146.277 13.8964 221.867 33.8479 217.289 66.0496C214.071 88.6879 180.574 95.6658 161.795 95.699C137.805 95.7414 118.568 78.461 123.854 53.838C128.708 31.2245 150.212 22.6304 169.794 15.395"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M174.057 100.059C179.558 118.869 182.397 138.618 185.781 157.889C188.619 174.055 188.247 190.696 191.251 206.717"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M184.925 145.84C167.035 145.575 131.42 142.645 131.42 142.645"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M142.344 116.86C144.977 130.905 148.159 145.087 149.4 159.347C149.986 166.078 139.689 162.388 136.118 161.787C133.88 161.411 119.939 161.34 119.154 158.602C118.883 157.656 119.299 151.946 119.304 151.857C119.707 145.044 120.169 138.24 120.321 131.415C120.36 129.669 118.299 116.994 121.958 116.973C128.74 116.934 135.535 119.885 142.376 120.263C146.862 120.511 151.319 120.303 155.785 120.656"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M111.886 119.855C105.859 112.182 98.5698 105.063 93.3345 96.8796"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M100.459 140.31C89.5077 149.638 77.4318 159.233 68.5155 170.717"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M65.9985 86.7432C67.4737 105.673 69.4863 124.619 67.9462 143.561C67.6476 147.234 67.8962 151.036 67.9644 154.713C67.9882 155.995 68.462 159.578 67.8006 156.051"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M66.6524 79.376C52.7727 79.532 39.7175 80.783 26.1472 83.3271C23.6728 83.791 17.6356 83.5783 17.1001 86.6422C16.0048 92.9099 17.9735 99.6646 18.6498 105.881C19.3838 112.628 19.0917 119.435 19.9852 126.171C21.2777 135.915 22.0605 145.862 23.5401 155.557C23.6372 156.192 24.1061 157.286 23.8806 157.921C23.7958 158.16 22.0171 159.198 22.8088 159.336C26.2924 159.946 31.4977 157.91 34.8686 157.278C39.2602 156.455 44.4111 156.124 47.9125 153.062C51.6101 149.828 58.8202 152.787 63.5851 151.894"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M56.958 98.2168C55.966 98.5999 54.5567 99.5924 55.0855 97.725C55.1356 97.5481 55.7503 95.1321 56.2407 95.8767C57.5474 97.8609 55.7154 100.507 55.109 97.2723"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M56.721 122.057C56.6268 121.118 56.5551 120.606 56.5373 119.693C56.5277 119.201 56.8638 118.433 56.5635 118.235C56.218 118.007 56.0404 119.779 55.8451 119.248C55.4395 118.146 55.9767 116.536 55.6664 117.39"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M56.8181 139.13C59.9222 138.71 58.0013 140.31 57.8304 140.141C57.2751 139.594 56.8166 138.995 56.3532 138.405C56.3466 138.397 56.5607 138.616 56.7163 138.587"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M47.8153 98.2914C46.4073 98.1802 45.0925 98.0863 43.7988 97.5607C43.4905 97.4354 42.8971 96.9705 42.4836 97.0018C41.4489 97.0799 40.469 98.4103 39.7114 98.9346C37.1889 100.68 35.2331 100.47 32.4046 100.022C31.8469 99.9336 31.2859 100.137 30.7351 100.222C29.2314 100.453 27.6544 100.38 26.1355 100.519C25.326 100.593 22.5618 100.562 24.3263 99.6428"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M48.8594 109.287C44.567 107.859 40.8522 106.182 36.6006 108.001C34.9374 108.712 32.8524 108.8 31.0842 109.132C30.7197 109.2 27.9217 110.091 28.6329 109.01"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M47.5077 123.784C44.8094 122.721 42.1082 121.573 39.3284 120.776C38.5332 120.548 37.4544 120.215 36.676 120.689C35.6757 121.297 34.7208 123.187 34.1401 124.261C33.8721 124.756 28.6175 120.834 27.5431 120.405"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <path
            d="M51.0702 137.361C48.1265 137.62 45.1415 137.818 42.2045 137.786C40.4102 137.767 39.079 137.529 37.2462 137.921C35.729 138.246 28.9746 141.922 28.3406 140.941"
            stroke="black"
            strokeWidth="6"
            strokeLinecap="round"
          />
        </svg>
      }
      description="Second, have your friends scan the QR code"
      buttonText="Next"
      back={() => setIndex((i) => i - 1)}
      next={() => setIndex((i) => i + 1)}
    />,
    <HowToCircle
      image={
        <svg width="302" height="243" viewBox="0 0 302 243" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M95.6403 22.1956C97.5045 41.3706 92.9404 60.1316 88.1621 78.599C87.49 81.1967 78.1423 112.24 79.6699 112.568C84.8341 113.674 91.075 113.328 96.2107 113.392C122.158 113.712 148.069 112.521 173.971 111.11C196.716 109.872 219.445 108.237 242.226 107.815C244.324 107.776 248.895 108.372 251.288 107.688C254.33 106.819 250.893 82.6218 250.655 81.0073C247.408 58.9873 240.232 37.8564 236.078 16.0483C235.63 13.694 235.569 13.2219 233.036 13.3232C219.418 13.8679 205.862 14.109 192.223 14.2104C152.242 14.5077 112.668 18.4565 72.8254 21.0549"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M81.661 13.7258C83.9107 36.8732 78.4029 59.5208 72.6366 81.8142C71.8255 84.95 60.5452 122.425 62.3886 122.82C68.6205 124.156 76.1518 123.738 82.3493 123.815C113.662 124.201 144.93 122.763 176.188 121.061C203.635 119.565 231.064 117.592 258.554 117.082C261.086 117.036 266.603 117.755 269.491 116.929C273.161 115.88 269.013 86.6704 268.726 84.7213C264.808 58.1395 256.149 32.631 251.136 6.30492C250.595 3.46292 250.521 2.89296 247.465 3.01525C231.032 3.67282 214.672 3.96389 198.213 4.0863C149.965 4.44515 127.984 8.5292 79.9044 11.6659"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M120.737 38.166C112.434 39.7228 97.0058 45.0436 101.597 56.7981C104.155 63.3462 118.864 62.2183 120.42 55.5306C122.904 44.8497 121.731 33.603 109.329 33.603"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M113.892 51.855C115.49 55.8784 117.694 64.5927 121.877 66.6846"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M133.285 40.4476C141.3 38.4156 154.176 32.7111 162.374 37.0254C169.031 40.5291 171.919 29.1152 179.612 32.5891C187.606 36.1993 204.589 39.5283 211.996 33.6031"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M132.144 54.1365C142.44 54.1365 151.599 52.9198 161.613 51.9184C166.899 51.3898 171.096 48.1559 176.633 48.4328C184.327 48.8175 192.544 49.5735 200.589 49.5735"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M103.626 84.9365C100.692 88.8093 98.7241 91.5306 97.9219 96.344"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M104.766 81.5142C108.813 85.5612 112.856 89.355 117.314 92.9216"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path d="M102.485 90.6401H113.892" stroke="black" strokeWidth="5" strokeLinecap="round" />
          <path
            d="M139.984 81.2421C140.314 84.098 140.471 87.1109 141.358 89.8705C141.489 90.2791 141.411 89.0086 141.358 88.5827C141.015 85.8441 139.407 79.6086 141.615 77.2499C142.955 75.8188 147.124 76.5898 148.698 77.0782C152.633 78.2993 150.122 82.9896 147.368 84.0539C146.309 84.463 145.143 84.6041 144.019 84.6978C143.268 84.7603 145.497 84.9974 146.23 85.17C149.015 85.8252 151.396 86.8171 152.132 89.7631C153.623 95.7268 142.073 92.646 140.757 89.3553"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M199.867 75.4468C193.385 75.7114 183.557 79.1558 182.589 86.7366C182.262 89.2968 185.065 90.0622 187.075 90.4498C190.607 91.1306 193.587 90.8254 196.39 88.5824"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M219.571 76.6055C219.268 80.3466 219.157 84.0921 218.605 87.8094C218.087 91.2945 217.99 91.4132 218.025 87.8953C218.055 84.8775 217.681 80.7014 219.249 77.9577C220.54 75.6983 224.21 76.8334 225.967 77.7001C232.048 80.7001 232.446 86.2912 226.954 90.428C224.406 92.3476 217.213 96.4317 214.162 93.9909"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M36.6272 110.249C28.8671 109.527 21.2376 109.343 14.4558 113.977C5.99156 119.761 -0.42403 133.572 5.00524 143.277C8.53829 149.592 17.52 152.105 24.07 153.185C32.1095 154.512 47.2468 155.8 52.1929 147.136C58.8906 135.403 47.6647 113.272 35.2537 109.301C29.4509 107.444 27.1907 110.354 23.6775 114.369"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M165.979 174.926C158.156 175.343 150.472 176.068 142.827 177.967C134.472 180.043 117.843 184.441 117.68 195.887C117.574 203.268 126.919 208.324 132.624 210.701C140.199 213.857 149.062 214.818 157.15 213.382C171.467 210.841 176.749 197.489 171.146 184.605C165.774 172.253 154.43 167.241 141.846 166.097"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M271.486 136.148C258.927 134.678 247.053 137.262 237.477 145.893C232.667 150.229 225.29 157.698 226.424 164.991C227.863 174.241 242.583 174.626 249.315 174.834C259.562 175.151 270.19 174.008 280.054 171.139C286.839 169.165 300.31 164.536 298.955 154.853C297.702 145.896 286.134 140.113 278.877 137.26C271.937 134.533 265.215 134.268 257.948 133.794"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M267.955 177.94C267.955 191.913 267.985 205.85 269.72 219.732"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M155.384 213.775C155.384 219.994 155.381 226.216 154.796 232.415C154.541 235.116 154.38 238.012 153.03 240.263"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M28.9753 159.693C28.0576 172.999 23.1148 185.855 17.7915 197.953"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M162.395 123.333C161.457 131.469 159.792 139.545 158.979 147.677"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M129.51 148.104C149.014 148.051 168.517 147.677 188.02 147.677"
            stroke="black"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M26.9529 176.299C32.6414 176.299 38.1845 176.408 43.7116 174.873"
            stroke="black"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <path
            d="M38.7196 168.455C39.945 172.802 40.7428 177.106 41.5722 181.529C41.9261 183.417 42.2901 183.853 44.3058 183.767C47.4585 183.633 51.7663 183.737 51.4768 179.865C51.1851 175.963 50.7004 169.782 46.2868 168.178C44.9782 167.702 42.9391 168.098 41.592 168.098C39.4725 168.098 37.487 168.07 35.5105 168.811"
            stroke="black"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <path
            d="M157.1 226.219C159.174 226.219 165.352 225.609 163.281 225.506C158.052 225.244 152.808 225.483 147.572 225.109C144.153 224.865 142.605 224.453 140.282 222.297C139.001 221.107 137.461 220.136 136.063 219.087"
            stroke="black"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <path
            d="M126.079 210.886C126.407 214.458 126.435 218.001 126.435 221.583C126.435 223.588 127.402 223.023 129.407 223.01C131.548 222.995 133.787 223.038 135.904 222.653C136.457 222.553 136.075 221.581 136.063 221.147C135.976 218.138 135.114 215.533 134.636 212.669"
            stroke="black"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <path
            d="M269.419 196.624C262.996 197.527 256.301 197.958 250.165 200.19"
            stroke="black"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <path
            d="M248.738 185.57C248.968 190.289 249.791 194.921 250.422 199.595C250.591 200.845 250.596 200.903 249.412 200.903C246.768 200.903 244.191 200.646 241.567 200.348C239.571 200.121 238.794 200.623 238.755 198.446C238.696 195.226 238.426 192.127 237.705 188.977C237.47 187.953 236.083 184.988 238.022 184.877C240.842 184.716 243.778 184.5 246.599 184.5"
            stroke="black"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg>
      }
      description="Last, answer questions and climb the leaderboard!"
      buttonText="Start"
      back={() => setIndex((i) => i - 1)}
      next={() => navigate('/upload')}
    />,
  ];

  return (
    <Layout>
      <div className="circle">{slides[index]}</div>
    </Layout>
  );
};

export default Home;
